import React, {useState, useRef, forwardRef, useImperativeHandle } from 'react'
import '../main.css'
import '../styles.css'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import clsx from 'clsx'
import { Tooltip } from '@material-ui/core'
import { faChartLine, faChartSimple, faGear, faHouse } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { findClass } from '../utils'

const DASH = {
    analitico:{id:"/dashboard/analitico",name:"Analítico",key:'analitico',icon: faChartLine},
    operacional:{id:"/dashboard/operacional",name:"Operacional",key:'operacional',icon: faGear},
    torre_controle:{id: "/torre_de_controle", name: "Torre de Controle", key: "torre_controle", icon: faChartSimple}
}

const Header=forwardRef(({collapse,previousTarget,previousMenu,route},ref)=>{
    const refHeader = useRef(null)
    const location = useLocation()
    const { pathname } = location

    const [activeDash, setActiveDash] = useState(DASH.analitico)

    useImperativeHandle(ref,()=>({
        setMark(){
            select()
        }
    }))

        function expand(e){
        e.stopPropagation()
        refHeader.current.focus()
        let option = findClass(e.target,"name-type")
        if(option) {
            let name = option.getAttribute('name')
            setActiveDash(DASH[name])
            select()
            route(DASH[name].id)
        }
        let target = findClass(e.target,"button-type",5)
        if(target){
            target.classList.toggle('expand')
        }
    }

    function select(){
        let target = refHeader.current.getElementsByClassName("selector-type-focus")[0]
        if(previousTarget.current) {
            previousTarget.current.classList.remove("inner-item-focus")
        }
        if(previousMenu.current){
            previousMenu.current.classList.remove("inner-item-focus")
        }
        target.classList.add("inner-item-focus")
        previousTarget.current = target
        route(activeDash.id)
    }

    function selectDashOption(key,e){
        e.stopPropagation()
        setActiveDash(DASH[key])
        route(DASH[key].id)
    }


    return (
        <div ref={refHeader} className={`header ${collapse&&'collapse'}`}>
            <div
                className='selector-type selector-focus'
                onClick={select}
            >
                <div className='f-r-c-c' >
                    <div className='icon-type'>
                        <FontAwesomeIcon style={{ width: '18px', height: '18px' }} icon={faHouse} color={'#ff7418'}/>
                    </div>
                    <div className='box-type'>
                        <div className='title-type'>Dashboard</div>
                        <div name={activeDash.key} className='name-type main'>{activeDash.name}</div>
                    </div>
                </div>
                   <div className='button-type' onClick={expand}>
                    <div className='header-arrow'></div>
                    <div className='options-type'>
                        {Object.values(DASH).filter(dash=>dash.key!=activeDash.key).map((dash,i)=>{
                            return <div key={`header-dash-option-${i}`} name={dash.key} className='name-type'>{dash.name}</div>
                        })}
                    </div>
                </div>
            </div>

            <div className='hover-dash-box'>
                <div className='hover-options'>
                    <div className='hover-title'>{activeDash.name}</div>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '1rem', marginTop: '0.5rem' }}>
                        {Object.values(DASH).map((option, i) => (
                            <div
                                key={`hover-dash-${i}`}
                                className={`hover-option ${activeDash.key === option.key ? 'active' : ''}`}
                                onClick={(e) => selectDashOption(option.key, e)}
                            >
                                <div className='hover-icon'>
                                    <Tooltip title={option.name}>
                                        <FontAwesomeIcon width={18} icon={option.icon} />
                                    </Tooltip>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            <div className={clsx('selector-type-focus', pathname.includes(activeDash.id) && 'inner-item-focus')} />
        </div>
    )
})

export default Header
